import { BugetManagerMergeListSchema, BugetManagerPayload } from "../types";

export const calculateTotalBudget = (parent: BugetManagerMergeListSchema, rows: BugetManagerMergeListSchema[], yearMonth: string, budgetInputs: BugetManagerPayload[] = []) => {
  const children = rows?.filter((row) => row?.parent_id === parent?.coa_id);

  return children?.reduce((acc, row) => {
    const override = budgetInputs?.find((b) => b?.coa_id === row?.coa_id && b?.year_month === yearMonth);

    if (override) return acc + (override?.budget ?? 0)

    const raw = row?.period_balance?.[yearMonth];
    if (!raw) return acc;

    const [valueStr] = String(raw).split("#");
    const value = Number(valueStr) || 0;

    return acc + value;
  }, 0);
};
